import { EnderecoBase } from "#/types";
import { request } from "#/utils/request";

/** Endpoints */
export const ENDPOINT_ENDERECO = "/enderecos/";

/**
 * @function buscaEnderecoPeloCep - GET Address
 * @param cep - zip code of desired address
 */
export const buscaEnderecoPeloCep = async (cep: string) =>
  (await request.get<EnderecoBase>(`${ENDPOINT_ENDERECO}${cep}`)).data;
